<template>
  <div
    class="billing-credit-card-form__wrapper"
    :class="{ [currentActive]: !!currentActive }"
  >
    <BillingCreditCardField
      name="ccNumber"
      label="Card number"
      :value="ccNumber"
      :currentActive.sync="currentActive"
      @change="updateField"
    />
    <div
      class="bottom"
      :class="{
        ['empty']: !exp && !cvv,
        ['cc-filled']: !exp && !cvv && ccNumber,
        ['one-empty']: (!exp || !cvv) && ccNumber
      }"
    >
      <BillingCreditCardField
        name="exp"
        label="Expiration date"
        type="exp"
        :value="exp"
        :currentActive.sync="currentActive"
        @change="updateField"
      />

      <BillingCreditCardField
        name="cvv"
        label="CVV"
        type="cvv"
        :value="cvv"
        :currentActive.sync="currentActive"
        @change="updateField"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";

// components
import BillingCreditCardField from "@/components/BillingCreditCardField";

export default Vue.component("BillingCreditCardForm", {
  components: {
    BillingCreditCardField
  },

  data() {
    return {
      ccNumber: "",
      cvv: "",
      exp: "",
      currentActive: null
    };
  },

  methods: {
    updateField(name, value) {
      this[name] = value;
    }
  },

  mounted() {
    // using this for setting up whether form is fully filled or not
    // to change parents buttons
    this.$watch(
      vm => [vm.ccNumber, vm.cvv, vm.exp].join(),
      val => {
        const [number, cvv, exp] = val.split(",");
        if (number && cvv && exp) {
          this.$emit("updstate", true, { number, cvv, exp });
        } else {
          this.$emit("updstate", false);
        }
      }
    );
  }
});
</script>

<style lang="scss" scoped>
$ns: "billing-credit-card-form";

.#{$ns}__wrapper {
  position: relative;
  background: $white;
  box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  width: 470px;
  height: 270px;
  /*padding: 62px 44px 52px 44px;*/
  display: flex;
  flex-direction: column;
  align-items: center;

  /deep/ .ccNumber {
    .empty {
      /*margin-top: 20px;*/
    }
  }

  .bottom {
    display: flex;
    width: 100%;
    /*margin-top: 38px;*/
    /*align-items: center;*/

    &.empty {
      /*margin-top: 64px;*/
    }

    &.cc-filled {
      /*margin-top: 50px;*/
    }

    &.one-empty {
      /*margin-top: 38px;*/
    }

    /deep/ .cvv {
      /*padding-left: 20px;*/
    }
  }
}
</style>
